
















  import { Component, Vue } from 'vue-property-decorator'  
  import ReadFamille from '@/components/compte/read/ReadFamille.vue'  
  import ReadAdresse from '@/components/compte/read/ReadAdresse.vue'  
  import ReadTickets from '@/components/compte/read/ReadTickets.vue'  
  import ReadPreference from '@/components/compte/read/ReadPreference.vue'  
  import ReadInscription from '@/components/compte/read/ReadInscription.vue'  
  
  
@Component({
  name:"ProfilAccount",
  components:{ReadFamille,ReadTickets,ReadPreference,ReadAdresse,ReadInscription}
})
export default class Profil extends Vue {
 
  loading=false

  get user() {
    return this.$store.myGetters.user
  }

  editAddress = false
  myAddress = { adrPostalCode:"49070", ctyId:18217}
  

  openDetail(){
    
  }
}
